// Function to animate counting
function animateCounting(targetElement, duration) {
  let startTimestamp;
  const startCount = 0;
  const endCount = parseInt(targetElement.textContent, 10); // Parse the initial value

  function step(timestamp) {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    const currentCount = Math.floor(progress * (endCount - startCount) + startCount);
    targetElement.textContent = currentCount;

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  }

  requestAnimationFrame(step);
}

// Observer callback
function handleIntersection(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const countElement = entry.target.querySelector(".stat .count");
      animateCounting(countElement, 1000); // Adjust the duration as needed
      observer.unobserve(entry.target); // Stop observing once counted
    }
  });
}

// Set up the Intersection Observer
const observer = new IntersectionObserver(handleIntersection, {
  root: null, // Use the viewport as the root
  rootMargin: "0px",
  threshold: 0.2, // Adjust as needed
});

// Observe all elements with the class "count-up"
const countUpElements = document.querySelectorAll(".stat .value");
countUpElements.forEach((element) => {
  observer.observe(element);
});
